module.exports = __webpack_public_path__ + "static/media/game-console-handheld.db6999c4.svg";